// extracted by mini-css-extract-plugin
module.exports = {"white":"bodySection-module--white--VpNCW","sectionGrey":"bodySection-module--sectionGrey--2yF4f","dark":"bodySection-module--dark--H9lS9"};